import { StatusCodes } from 'http-status-codes';


enum httpStatusCodes {
  'Something went wrong' = StatusCodes.INTERNAL_SERVER_ERROR,
  'Entity not found' = StatusCodes.NOT_FOUND,
  'Unauthorized' = StatusCodes.UNAUTHORIZED,
}

export default httpStatusCodes;
